import { writable } from 'svelte/store';
import ConfigDB from "./Config/ThemeConfig.js";
let configDB = ConfigDB.data;
// for login username 
export const userName = writable(localStorage.getItem('Name'));
export const isSidebar = writable(false);
export const isDarkMode = writable(false);
export const isSearchVisible = writable(false);
export const sidebarClose = writable(false);
export const langOpen = writable(false);
export const margin = writable(0);
//For lang
export const currentLang = writable(configDB.language.defaultLang);
// themecustomizer
export const tablist = writable(false);
export const tabId = writable("");
export const layoutClass = writable(configDB.settings.sidebar.layoutClass);
export const sidebarClass = writable(configDB.settings.sidebar.sidebarClass);
export const horizontalSidebar = writable(configDB.settings.sidebar.sidebarClass);
export const sidebarResponsive = writable(false);
export const selectLayoutName = writable(configDB.settings.sidebar.layoutClass);
export const pageBodyClass = writable(false);
// search bar
export const searchIcon = writable(false);
export const searchToggle = writable(false);
export const searchValue = writable("");
export const searchResult = writable([]);
export const isOpen = writable(false);
// for icons
export let iTag = writable('');
export let icons = writable('');
export let iconClick = writable(false);
// for sidebar
export const activeMenu = writable([]);
// for sticky
export let notes = writable([{
        "id": 1,
        "isDeleted": false
    }]);
// for list
export const listId = writable("list-home");
// for nav
export const toggleNav = writable(true);
export const toggleNav1 = writable(false);
// for Product
// for leftsidefilter
export const leftSideFilter = writable(false);
//  for grid
export const grid = writable(false);
// for grid class
export const classId = writable(3);
// for Modal
export const modalIsopen = writable(false);
export const viewModalProduct = writable([]);
export const selectData = writable([]);
// for cartdata
export const cart = writable([]);
// for sorting
export const sortBy = writable('');
export const values = writable({ min: 100, max: 950 });
// for filter
export const brand = writable([]);
export const category = writable('');
export const colors = writable('');
export const selectValue = writable();
//  for search
export const searchKeyword = writable('');
export const searchsResult = writable([]);
// export const listId = writable("list-home")
//for contact
export const contactMenuId = writable("organization-tab");
export const usersData = writable({
    "id": "v-pills-iduser",
    "name": "Mark jecno",
    "email": "markjecno@gmail.com",
    "img": "user.png",
    "gender": "Male"
});
export const personalData = writable([]);
export const editForm = writable(false);
export const personalContact = writable(0);
// for tasks
export const tasksTabId = writable("pills-created");
export const tasksManage = writable([]);
//for Bookmark
export const bookmarkId = writable("pills-created");
export const gridClass = writable(false);
export const bookmarkItem = writable([]);
export const newBookmarkAdd = writable([]);
export const open = writable(false);
export const editBookmark = writable({});
// for todo
export const todoAllmark = writable(false);
export const allTodoList = writable([]);
//for serachresult
export const searchResults = writable("all-link");
//for social app
export const tempId = writable("top-timeline");
// export const listIds = writable<string>("list-home")
//For Chat search
export const searchContact = writable("");
export const selectList = writable([{
        "img": "1.jpg",
        "name": "Vincent Porter",
        "status": "Hello Name",
        "class": "away"
    }]);
// export const searchToggle = writable<boolean>(false)
export const tabOpen = writable(false);
export const isOpens = writable(false);
//form wizard
export const selectId = writable("step-1");
